import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import React from 'react';
import type { FC } from 'react';

import Typograf from 'components/basic/Typograf';
import { BodyL, BodyM } from 'components/basic/Typography';
import AppsItems from 'components/layouts/FullFooter/AppsItems';
import SocialItems from 'components/layouts/FullFooter/SocialItems';
import { footerItems } from 'components/layouts/FullFooter/constants';

import s from './FullFooter.module.scss';

const FullFooter: FC<{ className?: string }> = ({ className }) => {
  const date = new Date();
  const year = `${date.getFullYear()}`;
  const items = footerItems.map(item => {
    const innerItems = item.items.map(subItem => {
      return (
        <BodyM
          Tag="a"
          key={subItem.href}
          href={subItem.href}
          className={s.link}
          onClick={(): void => {
            logEvent('Web_Site_Footer_Link_Clicked', {
              link_id: subItem.href,
            });
          }}
        >
          {subItem.text}
        </BodyM>
      );
    });

    return (
      <div key={item.header}>
        <BodyL className={cn('mb-5', s.header)}>{item.header}</BodyL>
        {innerItems}
      </div>
    );
  });

  items.push(<AppsItems />);
  items.push(<SocialItems />);

  return (
    <div className={className}>
      <Typograf>
        <div className={cn(s.wrapper, 'mt-sm-12 mt-xm-16 mt-lg-12')}>
          <div className={s.linksWrapper}>{items}</div>
        </div>
        <div className={s.descriptionWrapper}>
          <div className={s.description}>
            Copyright {'\u00A0'} {year} {'\u00A0'} © Welltory Inc. All rights
            reserved.
          </div>
        </div>
      </Typograf>
    </div>
  );
};

export default FullFooter;
